module.exports = __webpack_public_path__ + "static/media/blood.06087a75.svg";